import './Login.css';
import { useEffect } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useRecoilValue } from 'recoil';

import { authAtom } from '../_state';
import { useUserActions } from '../_actions';
import cryptString from '../../Portal/Useful/cryptString';

import logo from "../../Portal/assets/Logo Fives Blanc.png";
import Loc from '../../Loc/Loc';
import LanguageSelector from "../../Portal/Components/LanguageSelector/LanguageSelector";

export { Login };

function Login({ history }) {
    const auth = useRecoilValue(authAtom);
    const userActions = useUserActions();

    useEffect(() => {
        // redirect to home if already logged in
        if (auth) history.push('/');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // form validation rules
    const validationSchema = Yup.object().shape({
        username: Yup.string().email(Loc.trad().LoginMailValid).required(Loc.trad().LoginMailRequired),
        password: Yup.string().required(Loc.trad().LoginPasswordRequired)
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, setError, formState } = useForm(formOptions);
    const { errors, isSubmitting } = formState;

    function onSubmit({ username, password }) {
        if (password.length >= 8) { // pour ne pas crypter le mot de passe d'un tmpUser (première connexion) -> à enlever quand l'appli m-files déchiffra les mots de passe des users temporaires
            password = cryptString(password);
        }
        return userActions.login(username, password)
            .catch(error => {
                setError('apiError', { message: error });
            });
    }

    return (
        <div className="background-login">
            <div className="background-image"></div>
            <img src={logo} alt="logo Fives" style={{marginLeft: '40vw', width: '20vw'}}/>
            <div className="col-md-6 offset-md-3">
                <div className="card border-0">
                    <h4 className="card-header" style={{ background: "#AF007C", color: "white" }}>{Loc.trad().LoginTitle}</h4>
                    <div className="card-body">
                        <form onSubmit={handleSubmit(onSubmit)} style={{display:"inline"}}>
                            <div className="form-group">
                                <label>{Loc.trad().LoginID}</label>
                                <input name="username" type="text" {...register('username')} className={`form-control ${errors.username ? 'is-invalid' : ''}`} />
                                <div className="invalid-feedback">{errors.username?.message}</div>
                            </div>
                            <div className="form-group">
                                <label>{Loc.trad().LoginPassword}</label>
                                <input name="password" type="password" {...register('password')} className={`form-control ${errors.password ? 'is-invalid' : ''}`} />
                                <div className="invalid-feedback">{errors.password?.message}</div>
                            </div>
                            <div style={{display:"inherit"}}>
                                <button disabled={isSubmitting} className="btn btn-primary">
                                    {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                    {Loc.trad().LoginConnect}
                                </button>
                            </div>
                            {errors.apiError &&
                                <div className="alert alert-danger mt-3 mb-0">{errors.apiError?.message}</div>
                            }
                        </form>
                        {/* <form style={{ float:"right"}}>
                            <LanguageSelector setLanguage={() =>{}} color="rgb(175, 0, 124)"></LanguageSelector>
                        </form> */}
                    </div>
                </div>
            </div>
            <div className="welcome-login-page">{Loc.trad().LoginWelcome}</div>
        </div>
    )
}
